import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
const t = (key, params) => app.translator.trans('ppk2-profile.forum.avatar_gallery.' + key, params);

/** Name of a gallery avatar: its title, else the translated built-in name, else «№ id». */
export function avatarTitle(a) {
  if (a.title) return a.title;
  if (a.builtin) {
    const key = 'ppk2-profile.lib.avatars.builtin.' + a.builtin;
    const tr = app.translator.trans(key);
    if (tr && tr !== key && String(tr) !== key) return tr;
  }
  return '№ ' + a.id;
}

/**
 * v17 «Выбрать из галереи»: a grid of the enabled gallery avatars (circles). A click saves the
 * choice at once (POST /api/ppk2/avatar-gallery/{id}/select) and updates every avatar of the
 * player on the page (header, profile) without reloading. Attrs: user.
 */
export default class AvatarGalleryModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.items = null;
    this.saving = null;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/ppk2/avatar-gallery'
    }).then(r => {
      this.items = r.data || [];
      m.redraw();
    }).catch(() => {
      this.items = [];
      m.redraw();
    });
  }
  className() {
    return 'Ppk2AvatarGalleryModal Modal--large';
  }
  title() {
    return t('title');
  }
  content() {
    if (this.items === null) return m("div", {
      className: "Modal-body"
    }, m(LoadingIndicator, null));
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "helpText"
    }, t('help')), this.items.length ? m("div", {
      className: "Ppk2AvatarGrid"
    }, this.items.map(a => m("button", {
      type: "button",
      className: 'Ppk2AvatarGrid-item' + (this.saving === a.id ? ' is-saving' : ''),
      title: avatarTitle(a),
      "aria-label": avatarTitle(a),
      disabled: this.saving !== null,
      onclick: () => this.choose(a)
    }, m("img", {
      src: a.url,
      alt: "",
      loading: "lazy",
      referrerpolicy: "no-referrer"
    }), this.saving === a.id ? m(LoadingIndicator, {
      size: "small",
      display: "inline"
    }) : null))) : m("p", {
      className: "Ppk2Muted"
    }, t('empty')), m("div", {
      className: "Ppk2AvatarGalleryModal-actions"
    }, m(Button, {
      className: "Button",
      onclick: () => this.hide()
    }, t('cancel'))));
  }
  choose(a) {
    const user = this.attrs.user || app.session.user;
    this.saving = a.id;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ppk2/avatar-gallery/' + a.id + '/select',
      body: {
        userId: user.id()
      }
    }).then(r => {
      user.pushAttributes({
        avatarUrl: r.avatarUrl,
        avatarSrcset: r.avatarSrcset || null
      });
      // the header avatar etc. read the attribute on redraw; the cached colour is dropped
      user.avatarColor = null;
      this.hide();
      app.alerts.show({
        type: 'success'
      }, t('saved'));
      m.redraw();
    }).catch(() => {
      this.saving = null;
      m.redraw();
    });
  }
}
flarum.reg.add('ppk2-profile', 'forum/components/AvatarGalleryModal', AvatarGalleryModal);